/**
 * @author: subhasish.ghosh@zoom.us
 */

import axios from "axios";
import { getSessionStorage } from "./sessionUtils";
import store from "@redux/actions/store";
import { setAuthentication } from "@redux/actions/authActions";
import { isLocalEnvironment } from "@utils/utils";

const apiUrl = process.env.REACT_APP_API_URL;
const withCredentials = process.env.REACT_APP_API_WITH_CREDENTIALS === "true";

const axiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: withCredentials,
});

axiosInstance.interceptors.request.use(
  (config) => {
    /*
    // check if request is post or put or patch or delete
    if (["post", "put", "patch", "delete"].includes(config.method)) {
      // retrieve csrf token from session storage
      const csrfToken = getSessionStorage("csrf-token");

      // add the token to the headers if it exists
      if (csrfToken) {
        config.headers["X-XSRF-Token"] = csrfToken;
      }
    }
    */

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    store.dispatch(setAuthentication(true));
    return response;
  },
  (error) => {
    // handle 302 Found error
    if (
      error &&
      ((error.response && error.response.status === 302) ||
        error.code === "ERR_NETWORK")
    ) {
      store.dispatch(setAuthentication(false));
      return Promise.reject({
        message: "User is not authenticated",
      });
    }

    // return other errors as they are
    return Promise.reject(error);
  }
);

export default axiosInstance;
